
import {ref, computed, defineComponent, onMounted} from "vue";

export default defineComponent({
  name: "InstDesc6",
});
